<template>
  <div :class="$style.toolbar">
    <SCAIconButton
      :class="$style.button"
      size="small"
      appearance="secondary"
      icon="phosphor/check"
      :aria-label="$t('common.action.apply')"
      :title="$t('common.action.apply')"
      test-id="column-filter-apply"
      @click="emit('apply')"
    />
    <SCAIconButton
      :class="$style.button"
      size="small"
      appearance="secondary"
      icon="phosphor/arrow-counter-clockwise"
      :aria-label="$t('common.action.clear')"
      :title="$t('common.action.clear')"
      :disabled="resetDisabled"
      test-id="column-filter-reset"
      @click="emit('reset')"
    />
    <div :class="$style.content">
      <slot />
    </div>
    <slot name="trailing" />
  </div>
</template>

<script setup lang="ts">
import SCAIconButton from "../SCAIconButton.vue";

defineProps<{
  resetDisabled?: boolean;
}>();

const emit = defineEmits<{
  apply: [];
  reset: [];
}>();
</script>

<style module lang="scss">
.toolbar {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: var(--space-component-gap-small);
  box-sizing: content-box;
  height: var(--dimension-350);
  padding: var(--space-component-padding-small) var(--space-component-padding-medium);
  box-shadow: inset 0 -1px 0 var(--color-border-default);
}

.button:not(:disabled),
.button:not(:disabled) * {
  cursor: pointer;
}

.content {
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
}
</style>
